if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function scrollDown(){
    let top = $(document).scrollTop();
    if (top > 0) {
        $('header').addClass('scroll');
    } else {
        $('header').removeClass('scroll');
    }
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.getElementById("search-input").addEventListener("input", function() {
        this.parentElement.dataset.text = this.value;
    });

    $(window).scroll(function (event) {
        scrollDown();
    });


    //Slick Slider options
    setTimeout(function(){
        $('.sym-slides').slick();

        $('.hero-slides').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            fade: true,
            pauseOnHover: false,
            accessibility: false
        });
    },50);




    $('.review-slides').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows: false,
        dots: true,
        pauseOnHover: false,
        fade: true,
        responsive: [
            {
                breakpoint: 767
            }
        ]
    });

//    $('.quad-slides').slick({
//        arrows: true,
//        dots: false,
//        pauseOnHover: false,
//        fade: true,
//        prevArrow: $('.quad-slides-arrows__prev'),
//        nextArrow: $('.quad-slides-arrows__next'),
//        responsive: [
//            {
//                breakpoint: 768,
//                settings: {
//                    adaptiveHeight: true
//                }
//            }
//        ]
//    });

    $('.pillar-slides').slick({
        arrows: true,
        dots: false,
        autoplay: false,
        fade: false,
        accessibility: false,
        infinite: true,
        asNavFor: '.reason__copy',
        slidesToShow: 1.5,
        slidesToScroll: 1,
        prevArrow: '.reason-arrows__prev',
        nextArrow: '.reason-arrows__next',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.pillar-nav').slick({
        arrows: false,
        dots: false,
        autoplay: false,
        fade: true,
        accessibility: false,
        infinite: true,
        asNavFor: ".reason__image"
    });

    $('.sm-gallery-slides').slick({
        arrows: true,
        dots: false,
        pauseOnHover: false,
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: $('.sm-gallery-arrows__prev'),
        nextArrow: $('.sm-gallery-arrows__next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    $('.md-gallery-slides').slick({
        arrows: true,
        dots: false,
        pauseOnHover: false,
        fade: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        rows: 2,
        prevArrow: $('.sm-gallery-arrows__prev'),
        nextArrow: $('.sm-gallery-arrows__next'),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    rows: 4,
                    arrows: false
                }
            }
        ]
    });


    $(".video-iframe").on('click', function(event) {
        event.preventDefault();
        $.fancybox({
            'type' : 'iframe',
            // hide the related video suggestions and autoplay the video
            'href' : this.href.replace(new RegExp('watch\\?v=', 'i'), 'embed/') + '?rel=0&autoplay=1',
            'overlayShow' : true,
            'centerOnScroll' : true,
            'speedIn' : 100,
            'speedOut' : 50,
            'allowfullscreen':true,
            'width'         : '900px',
            'height'        : '550px',
            'autosize': false,
            'iframe' : {
                preload: false
            }
        });
    }); 

    //Fancybox options
    $('.fancybox-copy').fancybox({
        wrapCSS : 'fancybox-copy-holder',
        maxWidth: 850
    });
    

    //expand/collapse hidden content
    $('.expand-content').click(function(){
        event.preventDefault();
        $(this).next('.hidden-content').slideDown();
    });

    $('.collapse-content').click(function(){
        event.preventDefault();
        $(this).parent('.hidden-content').slideUp();
    });

    $('#meetingRFP_yes-signup-form').addClass('required');

    //Button Scroll to Form command
    $('a.btn-scroll-to-form').click(function(){
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".form-container").offset().top - 96
        }, 1500);
    });

    $(document).ready(function(){
        if ($(location.hash).length) {
            setTimeout(function(){
                var scrollTo = $(location.hash).outerHeight();
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(location.hash).offset().top - 136
                }, 1500);
            }, 200);
        }
    });

    //Capacity Chart Toggle
    $('#toggle-menu').find('.each-floor__title .each-floor__icon').click(function(){
        if($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open');
        } else {
            $('.each-floor__title').removeClass('open');
            $(this).parent().addClass('open');
        }
        $(this).parent().next().slideToggle();
        $(".each-floor__description").not($(this).parent().next()).slideUp();

    });

})();